/* unplugin-vue-components disabled */import { render } from "./tenant-ps.vue?vue&type=template&id=4307bb4b&scoped=true"
import script from "./tenant-ps.vue?vue&type=script&lang=js"
export * from "./tenant-ps.vue?vue&type=script&lang=js"

import "./tenant-ps.vue?vue&type=style&index=0&id=4307bb4b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4307bb4b"],['__file',"src/pages/tenant/settings/tenant-ps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4307bb4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4307bb4b', __exports__)) {
    api.reload('4307bb4b', __exports__)
  }
  
  module.hot.accept("./tenant-ps.vue?vue&type=template&id=4307bb4b&scoped=true", () => {
    api.rerender('4307bb4b', render)
  })

}


export default __exports__